import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import FrontPage from "components/FrontPage";
import Sidebar from "components/Sidebar";
import {
  MANAGE_TOOLS_SESSION_KEY,
  setManageToolsSession,
  useAppDispatch,
  useStore,
} from "lib/store/store";
import { PAGE_STORAGE_KEY } from "lib/theme";
import { tools } from "lib/data";
import {
  TgBulkSenderPage,
  TgVideoDownloaderPage,
  TgTranslatorPage,
} from "components/tools/ToolSubscriptionPage";
import TrendingOffers from "components/TrendingOffers";
import { DiwaliProvider, DiwaliToran } from "components/offers/DiwaliDecor";
import Support from "components/Support";
import Demos from "components/Demos";
import MoreTools from "components/MoreTools";
import ManageTools from "components/ManageTools";
import Popup from "components/Popup";
import { normalizePath, pageFromPathname, persistPage } from "lib/routes";

export default function HomePage() {
  const dispatch = useAppDispatch();
  const { isMobile, toggleSidebar, page, setPage } = useStore();
  const location = useLocation();
  const pathname = normalizePath(location.pathname);
  const isMounted = useRef(false);

  useEffect(() => {
    if (pathname !== "/manage-tools") {
      dispatch(setManageToolsSession({ tool: null, writeSession: false }));
      return;
    }
    const raw = sessionStorage.getItem(MANAGE_TOOLS_SESSION_KEY);
    if (raw && tools.some((t) => t.id === raw)) {
      dispatch(setManageToolsSession({ tool: raw, writeSession: false }));
    }
  }, [pathname, dispatch]);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    localStorage.setItem(PAGE_STORAGE_KEY, page);
  }, [page]);

  // Backup sync if PathSync in App didn't run yet (e.g. first paint).
  useEffect(() => {
    const fromPath = pageFromPathname(pathname);
    if (!fromPath) return;
    if (page !== fromPath) {
      setPage(fromPath);
      persistPage(fromPath);
    }
  }, [pathname, page, setPage]);

  return (
    <DiwaliProvider fireworks={page === "trending" || pathname === "/offers"}>
    <div className="flex h-dvh max-h-dvh min-h-0 overflow-hidden bg-[var(--dash-bg)] font-sans text-[var(--dash-text)]">
      <Sidebar />

      <div className="flex min-h-0 min-w-0 flex-1 flex-col md:ps-64">
        <main className="dashboard-scroll flex min-h-0 min-w-0 flex-1 flex-col overflow-x-clip overflow-y-auto">
          <div className="mx-auto w-full max-w-7xl px-4 py-4 md:px-8 md:py-8">
            {isMobile && (
              <header className="mb-6 flex items-center md:hidden">
                <button
                  id="hamburgerBtn"
                  onClick={toggleSidebar}
                  className="rounded-full p-2 text-[var(--dash-text-strong)] hover:bg-black/5 dark:hover:bg-white/10"
                >
                  <i className="fas fa-bars text-xl"></i>
                </button>
              </header>
            )}
            <DiwaliToran />
            {page === "front" && <FrontPage />}
            {page === "tgb" && <TgBulkSenderPage />}
            {page === "tgv" && <TgVideoDownloaderPage />}
            {page === "tgt" && <TgTranslatorPage />}
            {page === "trending" && <TrendingOffers />}
            {page === "support" && <Support />}
            {page === "demos" && <Demos />}
            {page === "more-tools" && <MoreTools />}
            {page === "manage-tools" && <ManageTools />}
          </div>
        </main>
      </div>
      <Popup />
    </div>
    </DiwaliProvider>
  );
}
